import { createNode } from '@glueapp/graph-types';

export const ConvertToJSON = createNode({
    id: 'Convert to JSON',
    name: 'Convert to JSON',
    description: 'Create an Convert to string',
    aiDescription:
        'Converts any input value to a JSON string via JSON.stringify. Connect any typed value to the "Input" port; the "String" output port provides the serialized JSON string.',
    category: 'JSON',
    color: '#bf7ee2',
    integration: undefined,
    inPorts: {
        Input: {
            kind: 'generic',
            identifier: 'T',
        },
    },
    outPorts: {
        String: { kind: 'string' },
    },
    execute: function (input) {
        const inputObject = input.inPorts.Input;
        const stringifiedInput = JSON.stringify(inputObject, null, 4);
        return { output: { String: stringifiedInput } };
    },
});
